export const UPDATE_TOKEN_INFO = 'UPDATE_TOKEN_INFO';
export const UPDATE_PAGE_STATUS = 'UPDATE_PAGE_STATUS';
export const UPDATE_MESSAGE_STATUS = 'UPDATE_MESSAGE_STATUS';

export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';

export const UPDATE_LOCATION_INFO = 'UPDATE_LOCATION_INFO';
export const UPDATE_LOCATION_INFO_SUCCESS = 'UPDATE_LOCATION_INFO_SUCCESS';
export const UPDATE_LOCATION_INFO_FAIL = 'UPDATE_LOCATION_INFO_FAIL';

//vote
export const FETCH_CAMPAIGNS = 'FETCH_CAMPAIGNS';
export const FETCH_CAMPAIGNS_SUCCESS = 'FETCH_CAMPAIGNS_SUCCESS';
export const FETCH_CAMPAIGNS_FAIL = 'FETCH_CAMPAIGNS_FAIL';

export const FETCH_PROJECT = 'FETCH_PROJECT';
export const FETCH_PROJECT_SUCCESS = 'FETCH_PROJECT_SUCCESS';
export const FETCH_PROJECT_FAIL = 'FETCH_PROJECT_FAIL';

export const FETCH_STATISTIC = 'FETCH_STATISTIC';
export const FETCH_STATISTIC_SUCCESS = 'FETCH_STATISTIC_SUCCESS';
export const FETCH_STATISTIC_FAIL = 'FETCH_STATISTIC_FAIL';
//end vote

export const SEND_EMAIL_CONTACT = 'SEND_EMAIL_CONTACT';
export const SEND_EMAIL_CONTACT_SUCCESS = 'SEND_EMAIL_CONTACT_SUCCESS';
export const SEND_EMAIL_CONTACT_FAIL = 'SEND_EMAIL_CONTACT_FAIL';

export const CHECK_KYC_COLLECTION = 'CHECK_KYC_COLLECTION';
export const CHECK_KYC_COLLECTION_DONE = 'CHECK_KYC_COLLECTION_DONE';
export const CHECK_KYC_COLLECTION_FAIL = 'CHECK_KYC_COLLECTION_FAIL';

export const SUBMIT_REGISTER = 'SUBMIT_REGISTER';
export const SUBMIT_REGISTER_DONE = 'SUBMIT_REGISTER_DONE';
export const SUBMIT_REGISTER_FAIL = 'SUBMIT_REGISTER_FAIL';
export const SUBMIT_REGISTER_UPLOAD_FILE = 'SUBMIT_REGISTER_UPLOAD_FILE';
export const SUBMIT_REGISTER_UPLOAD_FILE_DONE = 'SUBMIT_REGISTER_UPLOAD_FILE_DONE';
export const SUBMIT_REGISTER_UPLOAD_FILE_FAIL = 'SUBMIT_REGISTER_UPLOAD_FILE_FAIL';

export const FETCH_DISTRIBUTION_CODE = 'FETCH_DISTRIBUTION_CODE';
export const FETCH_DISTRIBUTION_CODE_DONE = 'FETCH_DISTRIBUTION_CODE_DONE';
export const FETCH_DISTRIBUTION_CODE_FAIL = 'FETCH_DISTRIBUTION_CODE_FAIL';

export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILED = 'FETCH_USER_FAILED';
export const MVP_GET_LIST_LANGUAGE = 'MVP_GET_LIST_LANGUAGE';

export const UPDATE_KAT_ADDRESS = 'UPDATE_KAT_ADDRESS';
export const UPDATE_KAT_ADDRESS_SUCCESS = 'UPDATE_KAT_ADDRESS_SUCCESS';
export const UPDATE_KAT_ADDRESS_FAILED = 'UPDATE_KAT_ADDRESS_FAILED';

export const FETCH_CODES_OF_USER = 'FETCH_CODES_OF_USER';
export const FETCH_CODES_OF_USER_SUCCESS = 'FETCH_CODES_OF_USER_SUCCESS';
export const FETCH_CODES_OF_USER_FAILED = 'FETCH_CODES_OF_USER_FAILED';

export const UPDATE_REDEEM_CODE = 'UPDATE_REDEEM_CODE';
export const UPDATE_REDEEM_CODE_SUCCESS = 'UPDATE_REDEEM_CODE_SUCCESS';
export const UPDATE_REDEEM_CODE_FAILED = 'UPDATE_REDEEM_CODE_FAILED';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';

export const UPDATE_PROFILE_PICTURE = 'UPDATE_PROFILE_PICTURE';
export const UPDATE_PROFILE_PICTURE_SUCCESS = 'UPDATE_PROFILE_PICTURE_SUCCESS';
export const UPDATE_PROFILE_PICTURE_FAILED = 'UPDATE_PROFILE_PICTURE_FAILED';

export const UPLOAD_IMAGE = 'UPLOAD_IMAGE';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILED = 'UPLOAD_IMAGE_FAILED';

export const UPLOAD_FILE = 'UPLOAD_FILE';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILED = 'UPLOAD_FILE_FAILED';

// Karma
export const GET_KARMA = 'GET_KARMA';
export const GET_KARMA_SUCCESS = 'GET_KARMA_SUCCESS';
export const GET_KARMA_FAILED = 'GET_KARMA_FAILED';

export const GET_KARMA_HISTORY = 'GET_KARMA_HISTORY';
export const GET_KARMA_HISTORY_SUCCESS = 'GET_KARMA_HISTORY_SUCCESS';
export const GET_KARMA_HISTORY_FAILED = 'GET_KARMA_HISTORY_FAILED';

// CREDITS
export const GET_CREDITS = 'GET_CREDITS';
export const GET_CREDITS_SUCCESS = 'GET_CREDITS_SUCCESS';
export const GET_CREDITS_FAILED = 'GET_CREDITS_FAILED';

export const GET_CREDITS_HISTORY = 'GET_CREDITS_HISTORY';
export const GET_CREDITS_HISTORY_SUCCESS = 'GET_CREDITS_HISTORY_SUCCESS';
export const GET_CREDITS_HISTORY_FAILED = 'GET_CREDITS_HISTORY_FAILED';

// KWALLET
export const SUBMIT_REQUEST_WITHDRAW = 'SUBMIT_REQUEST_WITHDRAW';
export const SUBMIT_REQUEST_WITHDRAW_SUCCESS = 'SUBMIT_REQUEST_WITHDRAW_SUCCESS';
export const SUBMIT_REQUEST_WITHDRAW_FAILED = 'SUBMIT_REQUEST_WITHDRAW_FAILED';

export const SUBMIT_DEPOSIT = 'SUBMIT_DEPOSIT';
export const SUBMIT_DEPOSIT_SUCCESS = 'SUBMIT_DEPOSIT_SUCCESS';
export const SUBMIT_DEPOSIT_FAILED = 'SUBMIT_DEPOSIT_FAILED';

export const RESET_SUBMIT_REQUEST = 'RESET_SUBMIT_REQUEST';

export const GET_KWALLET_HISTORY = 'GET_KWALLET_HISTORY';
export const GET_KWALLET_HISTORY_SUCCESS = 'GET_KWALLET_HISTORY_SUCCESS';
export const GET_KWALLET_HISTORY_FAILED = 'GET_KWALLET_HISTORY_FAILED';

// ORDER
export const GET_ORDER_HISTORY = 'GET_ORDER_HISTORY';
export const GET_ORDER_HISTORY_SUCCESS = 'GET_ORDER_HISTORY_SUCCESS';
export const GET_ORDER_HISTORY_FAILED = 'GET_ORDER_HISTORY_FAILED';

// ORDER
export const GET_SESSION_HISTORY = 'GET_SESSION_HISTORY';
export const GET_SESSION_HISTORY_SUCCESS = 'GET_SESSION_HISTORY_SUCCESS';
export const GET_SESSION_HISTORY_FAILED = 'GET_SESSION_HISTORY_FAILED';
// Blockchain
export const CONNECT_WALLET = 'CONNECT_WALLET';
export const CONNECT_WALLET_SUCCESS = 'CONNECT_WALLET_SUCCESS';

export const DISCONNECT_WALLET = 'DISCONNECT_WALLET';
export const DISCONNECT_WALLET_SUCCESS = 'DISCONNECT_WALLET_SUCCESS';

export const WATCH_INFO = 'WATCH_INFO';
export const WATCH_INFO_SUCCESS = 'WATCH_INFO_SUCCESS';
export const WATCH_INFO_FAIL = 'WATCH_INFO_FAIL';

export const TRANSFER_KAT = 'TRANSFER_KAT';
export const TRANSFER_KAT_SUCCESS = 'TRANSFER_KAT_SUCCESS';
export const TRANSFER_KAT_FAIL = 'TRANSFER_KAT_FAIL';

export const TRANSFER_KYTE = 'TRANSFER_KYTE';
export const TRANSFER_KYTE_SUCCESS = 'TRANSFER_KYTE_SUCCESS';
export const TRANSFER_KYTE_FAIL = 'TRANSFER_KYTE_FAIL';

export const SET_ACCOUNT_WALLET = 'SET_ACCOUNT_WALLET';
export const SET_ACCOUNT_WALLET_SUCCESS = 'SET_ACCOUNT_WALLET_SUCCESS';
export const SET_EDITTING = 'SET_EDITTING';

//BOUNTY-REPO
export const GET_USER_COGNITO_INFO = 'GET_USER_COGNITO_INFO';

export const FETCH_BOUNTY = 'FETCH_BOUNTY';
export const FETCH_BOUNTY_SUCCESS = 'FETCH_BOUNTY_SUCCESS';
export const FETCH_BOUNTY_FAIL = 'FETCH_BOUNTY_FAIL';

export const FETCH_TEAM_IN_BOUNTY = 'FETCH_TEAM_IN_BOUNTY';
export const FETCH_TEAM_IN_BOUNTY_SUCCESS = 'FETCH_TEAM_IN_BOUNTY_SUCCESS';
export const FETCH_TEAM_IN_BOUNTY_FAIL = 'FETCH_TEAM_IN_BOUNTY_FAIL';

export const GET_BOUNTY_USER = 'GET_BOUNTY_USER';
export const GET_BOUNTY_USER_SUCCESS = 'GET_BOUNTY_USER_SUCCESS';
export const GET_BOUNTY_USER_FAIL = 'GET_BOUNTY_USER_FAIL';

export const FETCH_BOUNTY_DETAIL = 'FETCH_BOUNTY_DETAIL';
export const FETCH_BOUNTY_DETAIL_SUCCESS = 'FETCH_BOUNTY_DETAIL_SUCCESS';
export const FETCH_BOUNTY_DETAIL_FAILED = 'FETCH_BOUNTY_DETAIL_FAILED';

export const FETCH_LIST_SALE_CAMPAIGN = 'FETCH_LIST_SALE_CAMPAIGN';
export const FETCH_LIST_SALE_CAMPAIGN_SUCCESS = 'FETCH_LIST_SALE_CAMPAIGN_SUCCESS';
export const FETCH_LIST_SALE_CAMPAIGN_FAIL = 'FETCH_LIST_SALE_CAMPAIGN_FAIL';

export const CREATE_TEAM = 'CREATE_TEAM';
export const CREATE_TEAM_SUCCESS = 'CREATE_TEAM_SUCCESS';
export const CREATE_TEAM_FAILED = 'CREATE_TEAM_FAILED';

export const OPEN_MODAL_TO_EDIT_TEAM = 'OPEN_MODAL_TO_EDIT_TEAM';
export const CLOSE_MODAL_TO_EDIT_TEAM = 'CLOSE_MODAL_TO_EDIT_TEAM';
export const EDIT_TEAM = 'EDIT_TEAM';
export const EDIT_TEAM_SUCCESS = 'EDIT_TEAM_SUCCESS';
export const EDIT_TEAM_FAILED = 'EDIT_TEAM_FAILED';

export const JOIN_TEAM = 'JOIN_TEAM';
export const JOIN_TEAM_SUCCESS = 'JOIN_TEAM_SUCCESS';
export const JOIN_TEAM_FAILED = 'JOIN_TEAM_FAILED';

export const UPLOAD_TEAM_IMAGE = 'UPLOAD_TEAM_IMAGE';
export const UPLOAD_TEAM_IMAGE_SUCCESS = 'UPLOAD_TEAM_IMAGE_SUCCESS';
export const UPLOAD_TEAM_IMAGE_FAILED = 'UPLOAD_TEAM_IMAGE_FAILED';

export const STORE_SPONSOR_INDENTITY = 'STORE_SPONSOR_INDENTITY';
export const STORE_SPONSOR_INDENTITY_SUCCESS = 'STORE_SPONSOR_INDENTITY_SUCCESS';
export const STORE_SPONSOR_INDENTITY_FAILED = 'STORE_SPONSOR_INDENTITY_FAILED';

export const UPLOAD_SPONSOR_IMAGE = 'UPLOAD_SPONSOR_IMAGE';
export const UPLOAD_SPONSOR_IMAGE_SUCCESS = 'UPLOAD_SPONSOR_IMAGE_SUCCESS';
export const UPLOAD_SPONSOR_IMAGE_FAILED = 'UPLOAD_SPONSOR_IMAGE_FAILED';

export const SUBMIT_RESULT = 'SUBMIT_RESULT';
export const SUBMIT_RESULT_SUCCESS = 'SUBMIT_RESULT_SUCCESS';
export const SUBMIT_RESULT_FAILED = 'SUBMIT_RESULT_FAILED';

export const CREATE_JOIN_TEAM_REQUEST = 'CREATE_JOIN_TEAM_REQUEST';
export const CREATE_JOIN_TEAM_REQUEST_SUCCESS = 'CREATE_JOIN_TEAM_REQUEST_SUCCESS';
export const CREATE_JOIN_TEAM_REQUEST_FAILED = 'CREATE_JOIN_TEAM_REQUEST_FAILED';

export const FETCH_JOINTEAMREQUEST = 'FETCH_JOINTEAMREQUEST';
export const FETCH_JOINTEAMREQUEST_SUCCESS = 'FETCH_JOINTEAMREQUEST_SUCCESS';
export const FETCH_JOINTEAMREQUEST_FAIL = 'FETCH_JOINTEAMREQUEST_FAIL';

export const HANDLE_REQUEST = 'HANDLE_REQUEST';
export const HANDLE_REQUEST_SUCCESS = 'HANDLE_REQUEST_SUCCESS';
export const HANDLE_REQUEST_FAIL = 'HANDLE_REQUEST_FAIL';

export const UPDATE_WINNER_WITHDRAW = 'UPDATE_WINNER_WITHDRAW';
export const UPDATE_WINNER_WITHDRAW_SUCCESS = 'UPDATE_WINNER_WITHDRAW_SUCCESS';
export const UPDATE_WINNER_WITHDRAW_FAIL = 'UPDATE_WINNER_WITHDRAW_FAIL';

export const REQUEST_JUDGES = 'REQUEST_JUDGES';
export const REQUEST_JUDGES_DONE = 'REQUEST_JUDGES_DONE';
export const REQUEST_JUDGES_FAIL = 'REQUEST_JUDGES_FAIL';

export const UPLOAD_PROFILE_IMAGE = 'UPLOAD_PROFILE_IMAGE';
export const UPLOAD_PROFILE_IMAGE_SUCCESS = 'UPLOAD_PROFILE_IMAGE_SUCCESS';
export const UPLOAD_PROFILE_IMAGE_FAILED = 'UPLOAD_PROFILE_IMAGE_FAILED';

export const UPDATE_PROFILE = 'UPDATE_PROFILE';

export const GET_TEAM = 'GET_TEAM';
export const GET_TEAM_SUCCESS = 'GET_TEAM_SUCCESS';
export const GET_TEAM_FAILED = 'GET_TEAM_FAILED';

export const GET_TEAM_MEMBERS = 'GET_TEAM_MEMBERS';
export const GET_TEAM_MEMBERS_SUCCESS = 'GET_TEAM_MEMBERS_SUCCESS';
export const GET_TEAM_MEMBERS_FAILED = 'GET_TEAM_MEMBERS_FAILED';

export const GET_TEAM_DETAIL = 'GET_TEAM_DETAIL';
export const GET_TEAM_DETAIL_SUCCESS = 'GET_TEAM_DETAIL_SUCCESS';
export const GET_TEAM_DETAIL_FAILED = 'GET_TEAM_DETAIL_FAILED';

export const GET_TEAM_BY_COGNITOID = 'GET_TEAM_BY_COGNITOID';
export const GET_TEAM_BY_COGNITOID_SUCCESS = 'GET_TEAM_BY_COGNITOID_SUCCESS';
export const GET_TEAM_BY_COGNITOID_FAILED = 'GET_TEAM_BY_COGNITOID_FAILED';

export const EDIT_DETAIL_TEAM = 'EDIT_DETAIL_TEAM';
export const EDIT_DETAIL_TEAM_SUCCESS = 'EDIT_DETAIL_TEAM_SUCCESS';
export const EDIT_DETAIL_TEAM_FAILED = 'EDIT_DETAIL_TEAM_FAILED';

export const SEND_INVITATION = 'SEND_INVITATION';
export const SEND_INVITATION_SUCCESS = 'SEND_INVITATION_SUCCESS';
export const SEND_INVITATION_FAILED = 'SEND_INVITATION_FAILED';
export const CLOSE_MODAL_TO_SEND_INVITATION = 'CLOSE_MODAL_TO_SEND_INVITATION';

export const HANDLE_INVITATION = 'HANDLE_INVITATION';
export const HANDLE_INVITATION_SUCCESS = 'HANDLE_INVITATION_SUCCESS';
export const HANDLE_INVITATION_FAILED = 'HANDLE_INVITATION_FAILED';

export const DECLINE_INVITATION = 'DECLINE_INVITATION';
export const DECLINE_INVITATION_SUCCESS = 'DECLINE_INVITATION_SUCCESS';
export const DECLINE_INVITATION_FAILED = 'DECLINE_INVITATION_FAILED';

export const JOIN_BOUNTY_BY_TEAM_SELECTED = 'JOIN_BOUNTY_BY_TEAM_SELECTED';
export const JOIN_BOUNTY_BY_TEAM_SELECTED_SUCCESS = 'JOIN_BOUNTY_BY_TEAM_SELECTED_SUCCESS';
export const JOIN_BOUNTY_BY_TEAM_SELECTED_FAILED = 'JOIN_BOUNTY_BY_TEAM_SELECTED_FAILED';

export const UPLOAD_JOIN_BOUNTY_FILE = 'UPLOAD_JOIN_BOUNTY_FILE';
export const UPLOAD_JOIN_BOUNTY_FILE_SUCCESS = 'UPLOAD_JOIN_BOUNTY_FILE_SUCCESS';
export const UPLOAD_JOIN_BOUNTY_FILE_FAILED = 'UPLOAD_JOIN_BOUNTY_FILE_FAILED';

export const LEAVE_BOUNTY = 'LEAVE_BOUNTY';
export const LEAVE_BOUNTY_SUCCESS = 'LEAVE_BOUNTY_SUCCESS';
export const LEAVE_BOUNTY_FAILED = 'LEAVE_BOUNTY_FAILED';

export const REMOVE_MEMBER = 'REMOVE_MEMBER';
export const REMOVE_MEMBER_SUCCESS = 'REMOVE_MEMBER_SUCCESS';
export const REMOVE_MEMBER_FAILED = 'REMOVE_MEMBER_FAILED';

export const REMOVE_PENDING_USER = 'REMOVE_PENDING_USER';
export const REMOVE_PENDING_USER_SUCCESS = 'REMOVE_PENDING_USER_SUCCESS';
export const REMOVE_PENDING_USER_FAILED = 'REMOVE_PENDING_USER_FAILED';

export const CHANGE_NAME_MEMBER = 'CHANGE_NAME_MEMBER';
export const CHANGE_NAME_MEMBER_SUCCESS = 'CHANGE_NAME_MEMBER_SUCCESS';
export const CHANGE_NAME_MEMBER_FAILED = 'CHANGE_NAME_MEMBER_FAILED';

export const UPLOAD_PRESENTATION_FILE = 'UPLOAD_PRESENTATION_FILE';
export const UPLOAD_PRESENTATION_FILE_SUCCESS = 'UPLOAD_PRESENTATION_FILE_SUCCESS';
export const UPLOAD_PRESENTATION_FILE_FAILED = 'UPLOAD_PRESENTATION_FILE_FAILED';

export const UPLOAD_DEMO_FILE = 'UPLOAD_DEMO_FILE';
export const UPLOAD_DEMO_FILE_SUCCESS = 'UPLOAD_DEMO_FILE_SUCCESS';
export const UPLOAD_DEMO_FILE_FAILED = 'UPLOAD_DEMO_FILE_FAILED';

export const SUBMIT_CODE_HACKATHON = 'SUBMIT_CODE_HACKATHON';
export const SUBMIT_CODE_HACKATHON_SUCCESS = 'SUBMIT_CODE_HACKATHON_SUCCESS';
export const SUBMIT_CODE_HACKATHON_FAIL = 'SUBMIT_CODE_HACKATHON_FAIL';

export const OPEN_MODAL_TO_SHOW_SUBMISSION_TEAM = 'OPEN_MODAL_TO_SHOW_SUBMISSION_TEAM';
export const GET_BOUNTY_SUBMISSION = 'GET_BOUNTY_SUBMISSION';
export const GET_BOUNTY_SUBMISSION_SUCCESS = 'GET_BOUNTY_SUBMISSION_SUCCESS';
export const GET_BOUNTY_SUBMISSION_FAILED = 'GET_BOUNTY_SUBMISSION_FAILED';

export const JOIN_BOUNTY_CHALLENGE = 'JOIN_BOUNTY_CHALLENGE';
export const JOIN_BOUNTY_CHALLENGE_SUCCESS = 'JOIN_BOUNTY_CHALLENGE_SUCCESS';
export const JOIN_BOUNTY_CHALLENGE_FAILED = 'JOIN_BOUNTY_CHALLENGE_FAILED';

export const MARKED_SUBMIT_ARTICLE = 'MARKED_SUBMIT_ARTICLE';
export const MARKED_SUBMIT_ARTICLE_SUCCESS = 'MARKED_SUBMIT_ARTICLE_SUCCESS';
export const MARKED_SUBMIT_ARTICLE_FAILED = 'MARKED_SUBMIT_ARTICLE_FAILED';

export const UPLOAD_PROJECT_FILE = 'UPLOAD_PROJECT_FILE';
export const UPLOAD_PROJECT_FILE_SUCCESS = 'UPLOAD_PROJECT_FILE_SUCCESS';
export const UPLOAD_PROJECT_FILE_FAILED = 'UPLOAD_PROJECT_FILE_FAILED';

export const SEND_REQUEST_FOR_PROPOSAL = 'SEND_REQUEST_FOR_PROPOSAL';
export const SEND_REQUEST_FOR_PROPOSAL_SUCCESS = 'SEND_REQUEST_FOR_PROPOSAL_SUCCESS';
export const SEND_REQUEST_FOR_PROPOSAL_FAILED = 'SEND_REQUEST_FOR_PROPOSAL_FAILED';

export const GET_VOTE_CAMPAIGN = 'GET_VOTE_CAMPAIGN';
export const GET_VOTE_CAMPAIGN_SUCCESS = 'GET_VOTE_CAMPAIGN_SUCCESS';
export const GET_VOTE_CAMPAIGN_FAILED = 'GET_VOTE_CAMPAIGN_FAILED';

export const VOTE_FOR_FAVORITE_TEAM = 'VOTE_FOR_FAVORITE_TEAM';
export const VOTE_FOR_FAVORITE_TEAM_SUCCESS = 'VOTE_FOR_FAVORITE_TEAM_SUCCESS';
export const VOTE_FOR_FAVORITE_TEAM_FAILED = 'VOTE_FOR_FAVORITE_TEAM_FAILED';

export const CHECK_USER_VOTED_FOR_FAVORITE_TEAM = 'CHECK_USER_VOTED_FOR_FAVORITE_TEAM';
export const CHECK_USER_VOTED_FOR_FAVORITE_TEAM_SUCCESS = 'CHECK_USER_VOTED_FOR_FAVORITE_TEAM_SUCCESS';
export const CHECK_USER_VOTED_FOR_FAVORITE_TEAM_FAILED = 'CHECK_USER_VOTED_FOR_FAVORITE_TEAM_FAILED';

export const GET_BOUNTIES_OF_TEAM = 'GET_BOUNTIES_OF_TEAM';
export const GET_BOUNTIES_OF_TEAM_SUCCESS = 'GET_BOUNTIES_OF_TEAM_SUCCESS';
export const GET_BOUNTIES_OF_TEAM_FAILED = 'GET_BOUNTIES_OF_TEAM_FAILED';

export const UPDATE_MEMBER_JOIN_BOUNTY = 'UPDATE_MEMBER_JOIN_BOUNTY';
export const UPDATE_MEMBER_JOIN_BOUNTY_SUCCESS = 'UPDATE_MEMBER_JOIN_BOUNTY_SUCCESS';
export const UPDATE_MEMBER_JOIN_BOUNTY_FAILED = 'UPDATE_MEMBER_JOIN_BOUNTY_FAILED';

export const UPDATE_CHALLENGE_OF_TEAM = 'UPDATE_CHALLENGE_OF_TEAM';
export const UPDATE_CHALLENGE_OF_TEAM_SUCCESS = 'UPDATE_CHALLENGE_OF_TEAM_SUCCESS';
export const UPDATE_CHALLENGE_OF_TEAM_FAILED = 'UPDATE_CHALLENGE_OF_TEAM_FAILED';

export const BID_MENTOR = 'BID_MENTOR';
export const BID_MENTOR_SUCCESS = 'BID_MENTOR_SUCCESS';
export const BID_MENTOR_FAILED = 'BID_MENTOR_FAILED';

export const GET_BID_MENTOR = 'GET_BID_MENTOR';
export const GET_BID_MENTOR_SUCCESS = 'GET_BID_MENTOR_SUCCESS';
export const GET_BID_MENTOR_FAILED = 'GET_BID_MENTOR_FAILED';

//Codebase

export const FETCH_CODEBASE = 'FETCH_CODEBASE';
export const FETCH_CODEBASE_SUCCESS = 'FETCH_CODEBASE_SUCCESS';
export const FETCH_CODEBASE_FAILED = 'FETCH_CODEBASE_FAILED';

export const FETCH_CODEBASES = 'FETCH_CODEBASES';
export const FETCH_CODEBASES_SUCCESS = 'FETCH_CODEBASES_SUCCESS';
export const FETCH_CODEBASES_FAILED = 'FETCH_CODEBASES_FAILED';

export const GET_README = 'GET_README';
export const GET_README_SUCCESS = 'GET_README_SUCCESS';
export const GET_README_FAIL = 'GET_README_FAIL';

export const GET_KDNA = 'GET_KDNA';
export const GET_KDNA_SUCCESS = 'GET_KDNA_SUCCESS';
export const GET_KDNA_FAIL = 'GET_KDNA_FAIL';

export const GET_SUMMARY = 'GET_SUMMARY';
export const GET_SUMMARY_SUCCESS = 'GET_SUMMARY_SUCCESS';
export const GET_SUMMARY_FAIL = 'GET_SUMMARY_FAIL';

export const GET_COMMITS = 'GET_COMMITS';
export const GET_COMMITS_SUCCESS = 'GET_COMMITS_SUCCESS';
export const GET_COMMITS_FAIL = 'GET_COMMITS_FAIL';

export const GET_CODEBASE_SPONSORS = 'GET_CODEBASE_SPONSORS';
export const GET_CODEBASE_SPONSORS_SUCCESS = 'GET_CODEBASE_SPONSORS_SUCCESS';
export const GET_CODEBASE_SPONSORS_FAILED = 'GET_CODEBASE_SPONSORS_FAILED';

export const UPDATE_CODEBASE_SPONSOR = 'UPDATE_CODEBASE_SPONSOR';
export const UPDATE_CODEBASE_SPONSOR_SUCCESS = 'UPDATE_CODEBASE_SPONSOR_SUCCESS';
export const UPDATE_CODEBASE_SPONSOR_FAILED = 'UPDATE_CODEBASE_SPONSOR_FAILED';

export const FETCH_ALL_REFERENCES = 'FETCH_ALL_REFERENCES';
export const FETCH_ALL_REFERENCES_SUCCESS = 'FETCH_ALL_REFERENCES_SUCCESS';
export const FETCH_ALL_REFERENCES_FAILED = 'FETCH_ALL_REFERENCES_FAILED';
export const UPDATE_REFERENCE = 'UPDATE_REFERENCE';

export const FETCH_ALL_POSITION = 'FETCH_ALL_POSITION';
export const FETCH_ALL_POSITION_SUCCESS = 'FETCH_ALL_POSITION_SUCCESS';
export const FETCH_ALL_POSITION_FAILED = 'FETCH_ALL_POSITION_FAILED';

export const CHECK_PUBLIC_USERNAME = 'CHECK_PUBLIC_USERNAME';
export const CHECK_PUBLIC_USERNAME_SUCCESS = 'CHECK_PUBLIC_USERNAME_SUCCESS';
export const CHECK_PUBLIC_USERNAME_FAILED = 'CHECK_PUBLIC_USERNAME_FAILED';

export const FETCH_PUBLIC_USER_INFO = 'FETCH_PUBLIC_USER_INFO';
export const FETCH_PUBLIC_USER_INFO_SUCCESS = 'FETCH_PUBLIC_USER_INFO_SUCCESS';
export const FETCH_PUBLIC_USER_INFO_FAILED = 'FETCH_PUBLIC_USER_INFO_FAILED';

export const FETCH_PUBLIC_USER_TEAMS = 'FETCH_PUBLIC_USER_TEAMS';
export const FETCH_PUBLIC_USER_TEAMS_SUCCESS = 'FETCH_PUBLIC_USER_TEAMS_SUCCESS';
export const FETCH_PUBLIC_USER_TEAMS_FAILED = 'FETCH_PUBLIC_USER_TEAMS_FAILED';

export const UPDATE_BOUNTY_USER_DATA = 'UPDATE_BOUNTY_USER_DATA';
export const UPDATE_BOUNTY_USER_DATA_SUCCESS = 'UPDATE_BOUNTY_USER_DATA_SUCCESS';
export const UPDATE_BOUNTY_USER_DATA_FAILED = 'UPDATE_BOUNTY_USER_DATA_FAILED';

export const GET_BOUNTY_MENTOR_EVALUATION = 'GET_BOUNTY_MENTOR_EVALUATION';
export const GET_BOUNTY_MENTOR_EVALUATION_SUCCESS = 'GET_BOUNTY_MENTOR_EVALUATION_SUCCESS';
export const GET_BOUNTY_MENTOR_EVALUATION_FAILED = 'GET_BOUNTY_MENTOR_EVALUATION_FAILED';

export const SUBMIT_EVALUATION = 'SUBMIT_EVALUATION';
export const SUBMIT_EVALUATION_SUCCESS = 'SUBMIT_EVALUATION_SUCCESS';
export const SUBMIT_EVALUATION_FAILED = 'SUBMIT_EVALUATION_FAILED';

export const FETCH_LIST_CODE_BASE = 'FETCH_LIST_CODE_BASE';
export const FETCH_LIST_CODE_BASE_SUCCESS = 'FETCH_LIST_CODE_BASE_SUCCESS';
export const FETCH_LIST_CODE_BASE_FAIL = 'FETCH_LIST_CODE_BASE_FAIL';

export const FETCH_LIST_CODE_BASE_DETAIL = 'FETCH_LIST_CODE_BASE_DETAIL';
export const FETCH_LIST_CODE_BASE_DETAIL_SUCCESS = 'FETCH_LIST_CODE_BASE_DETAIL_SUCCESS';
export const FETCH_LIST_CODE_BASE_DETAIL_FAILED = 'FETCH_LIST_CODE_BASE_DETAIL_FAILED';

export const FETCH_RELEASE_DETAIL = 'FETCH_RELEASE_DETAIL';
export const FETCH_RELEASE_DETAIL_SUCCESS = 'FETCH_RELEASE_DETAIL_SUCCESS';
export const FETCH_RELEASE_DETAIL_FAILED = 'FETCH_RELEASE_DETAIL_FAILED';


export const POST_NFT_TRANSACTION = 'POST_NFT_TRANSACTION';
export const POST_NFT_TRANSACTION_SUCCESS = 'POST_NFT_TRANSACTION_SUCCESS';
export const POST_NFT_TRANSACTION_FAILED = 'POST_NFT_TRANSACTION_FAILED';

export const GET_LICENSE = 'GET_LICENSE';
export const GET_LICENSE_SUCCESS = 'GET_LICENSE_SUCCESS';
export const GET_LICENSE_FAILED = 'GET_LICENSE_FAILED';


export const GET_TRANSACTION = 'GET_TRANSACTION';
export const GET_TRANSACTION_SUCCESS = 'GET_TRANSACTION_SUCCESS';
export const GET_TRANSACTION_FAILED = 'GET_TRANSACTION_FAILED';


export const GET_LICENSE_BY_USER = 'GET_LICENSE';
export const GET_LICENSE_BY_USER_SUCCESS = 'GET_LICENSE_SUCCESS';
export const GET_LICENSE_BY_USER_FAILED = 'GET_LICENSE_FAILED';


export const FETCH_SESSION_DETAIL = 'FETCH_SESSION_DETAIL';
export const FETCH_SESSION_DETAIL_SUCCESS = 'FETCH_SESSION_DETAIL_SUCCESS';
export const FETCH_SESSION_DETAIL_FAILED = 'FETCH_SESSION_DETAIL_FAILED';

export const FETCH_SESSION_TOKEN = 'FETCH_SESSION_TOKEN';
export const FETCH_SESSION_TOKEN_SUCCESS = 'FETCH_SESSION_TOKEN_SUCCESS';
export const FETCH_SESSION_TOKEN_FAILED = 'FETCH_SESSION_TOKEN_FAILED';

export const FETCH_SESSION_CATEGORIES = 'FETCH_SESSION_CATEGORIES';
export const FETCH_SESSION_CATEGORIES_SUCCESS = 'FETCH_SESSION_CATEGORIES_SUCCESS';
export const FETCH_SESSION_CATEGORIES_FAILED = 'FETCH_SESSION_CATEGORIES_FAILED';


export const FETCH_CREATE_SESSION = 'FETCH_CREATE_SESSION';
export const FETCH_CREATE_SESSION_SUCCESS = 'FETCH_CREATE_SESSION_SUCCESS';
export const FETCH_CREATE_SESSION_FAILED = 'FETCH_CREATE_SESSION_FAILED';


export const FETCH_UPDATE_SESSION = 'FETCH_UPDATE_SESSION';
export const FETCH_UPDATE_SESSION_SUCCESS = 'FETCH_UPDATE_SESSION_SUCCESS';
export const FETCH_UPDATE_SESSION_FAILED = 'FETCH_UPDATE_SESSION_FAILED';
export const RESET_SUBMIT_SESSION = 'RESET_SUBMIT_SESSION';

export const FETCH_REMOVE_SESSION = 'FETCH_REMOVE_SESSION';
export const FETCH_REMOVE_SESSION_SUCCESS = 'FETCH_REMOVE_SESSION_SUCCESS';
export const FETCH_REMOVE_SESSION_FAILED = 'FETCH_REMOVE_SESSION_FAILED';


export const FETCH_REGISTER_SESSION = 'FETCH_REGISTER_SESSION';
export const FETCH_REGISTER_SESSION_SUCCESS = 'FETCH_REGISTER_SESSION_SUCCESS';
export const FETCH_REGISTER_SESSION_FAILED = 'FETCH_REGISTER_SESSION_FAILED';

export const FETCH_TECD_PACKAGES = 'FETCH_TECD_PACKAGES';
export const FETCH_TECD_PACKAGES_SUCCESS = 'FETCH_TECD_PACKAGES_SUCCESS';
export const FETCH_TECD_PACKAGES_FAILED = 'FETCH_TECD_PACKAGES_FAILED';


export const FETCH_UPLOAD_FILE = 'FETCH_UPLOAD_FILE';
export const FETCH_UPLOAD_FILE_SUCCESS = 'FETCH_UPLOAD_FILE_SUCCESS';
export const FETCH_UPLOAD_FILE_FAILED = 'FETCH_UPLOAD_FILE_FAILED';

export const FETCH_HISTORY_SESSIONS = 'FETCH_HISTORY_SESSIONS';
export const FETCH_HISTORY_SESSIONS_SUCCESS = 'FETCH_HISTORY_SESSIONS_SUCCESS';
export const FETCH_HISTORY_SESSIONS_FAILED = 'FETCH_HISTORY_SESSIONS_FAILED';

export const FETCH_HISTORY_TRANSACTIONS = 'FETCH_HISTORY_TRANSACTIONS';
export const FETCH_HISTORY_TRANSACTIONS_SUCCESS = 'FETCH_HISTORY_TRANSACTIONS_SUCCESS';
export const FETCH_HISTORY_TRANSACTIONS_FAILED = 'FETCH_HISTORY_TRANSACTIONS_FAILED';

export const FETCH_TRACKING_SESSION = 'FETCH_TRACKING_SESSION';
export const FETCH_TRACKING_SESSION_SUCCESS = 'FETCH_TRACKING_SESSION_SUCCESS';
export const FETCH_TRACKING_SESSION_FAILED = 'FETCH_TRACKING_SESSION_FAILED';


export const FETCH_ACCEPT_REJECT_SESSION = 'FETCH_ACCEPT_REJECT_SESSION';
export const FETCH_ACCEPT_REJECT_SESSION_SUCCESS = 'FETCH_ACCEPT_REJECT_SESSION_SUCCESS';
export const FETCH_ACCEPT_REJECT_SESSION_FAILED = 'FETCH_ACCEPT_REJECT_SESSION_FAILED';

export const FETCH_VERIFY_JOIN_SESSION = 'FETCH_VERIFY_JOIN_SESSION';
export const FETCH_VERIFY_JOIN_SESSION_SUCCESS = 'FETCH_VERIFY_JOIN_SESSION_SUCCESS';
export const FETCH_VERIFY_JOIN_SESSION_FAILED = 'FETCH_VERIFY_JOIN_SESSION_FAILED';


export const RESUBMIT_SESSION = 'RESUBMIT_SESSION';
export const RESUBMIT_SESSION_SUCCESS = 'RESUBMIT_SESSION_SUCCESS';
export const RESUBMIT_SESSION_FAILED = 'RESUBMIT_SESSION_FAILED';
